import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { createInboxEntriesSlice } from './actions';
import { InboxEntriesStore } from './types';
import { ZustandStores } from '../../utils';
import { createIndexedDBStorage } from '../../utils/indexedDBAdapter';

export const useInboxEntriesStore = create<InboxEntriesStore>()(
  persist(
    (set, get, store) => ({
      ...createInboxEntriesSlice(set, get, store),
    }),
    {
      name: ZustandStores.INBOX_ENTRIES,
      storage: createJSONStorage(() => createIndexedDBStorage()),
      version: 2,
      partialize: (state) => ({
        taskManager: {
          taskGroups: {
            taskGroups: state.taskManager.taskGroups.taskGroups,
            exclusiveStartKey: state.taskManager.taskGroups.exclusiveStartKey,
          },
        },
      }),
      merge: (persistedState, currentState) => {
        const persisted = persistedState as Partial<InboxEntriesStore>;
        const persistedTaskGroups = persisted.taskManager?.taskGroups;
        const currentTaskGroups =
          currentState.taskManager.taskGroups.taskGroups;
        const shouldHydrateTaskGroups = currentTaskGroups.length === 0;
        return {
          ...currentState,
          taskManager: {
            ...currentState.taskManager,
            taskGroups: shouldHydrateTaskGroups
              ? {
                  ...currentState.taskManager.taskGroups,
                  ...persistedTaskGroups,
                }
              : currentState.taskManager.taskGroups,
          },
        };
      },
      migrate: () => {
        // v2: removed doboxEntries slice entirely - return empty to force fresh state
        return {} as Partial<InboxEntriesStore>;
      },
    },
  ),
);
